import moment, { Moment } from 'moment';
import {
  CriteriosRemuneracao,
  ConvencaoJurosFixo,
  IndexadorAtualizacaoMonetaria,
  TipoProjecao,
  PeriodicidadeCorrecao,
  IndexadorRemuneracao,
  DefasagemFixingBase,
  Remuneracao,
  DefasagemFixingDiario,
  DefasagemFixingAnual,
  DefasagemFixingMensal,
  TipoProRata,
  CustoEmissao,
  Custodiante,
} from 'common/genericTypes';
import { typedAction } from 'store/modules/base';
import { multaMoraFieldsInitialState } from 'common/interfaces/MultaMoraFields';

export const indicePreco: { [key: string]: boolean } = {
  [IndexadorAtualizacaoMonetaria.IGPM]: true,
  [IndexadorAtualizacaoMonetaria.IPCA]: true,
  [IndexadorAtualizacaoMonetaria.USD]: false,
};

export const criteriosRemuneracaoInitialState: CriteriosRemuneracao = {
  moedaEmissao: '',
  dataEmissao: moment(),
  dataInicioRentabilidade: moment(),
  inicioRentabilidade: undefined,
  remuneracao: {},
  custodiantes: [],
  custoEmissao: {
    feeLaqusBruto: 0,
  },
  tipoPagamento: '',
  convencaoCalendarioPagamento: '',
  periodicidadeAmortizacao: '',
  primeiraParcelaAmortizacao: null,
  periodicidadeJuros: '',
  primeiraParcelaJuros: null,
  ...multaMoraFieldsInitialState,
};

export interface Field {
  name: keyof Omit<CriteriosRemuneracao, 'remuneracao'>;
  value: undefined | null | string | number | Moment | Array<Custodiante>;
}

export interface RemuneracaoField {
  name: keyof Remuneracao;
  value:
  | IndexadorRemuneracao
  | DefasagemFixingBase
  | DefasagemFixingDiario
  | DefasagemFixingMensal
  | DefasagemFixingAnual
  | number
  | PeriodicidadeCorrecao
  | TipoProRata
  | boolean
  | TipoProjecao
  | ConvencaoJurosFixo
  | undefined
  | null;
}

export interface CustoEmissaoField {
  name: keyof CustoEmissao;
  value: undefined | null | number;
}

export const updateField = (field: Field) => {
  return typedAction('notaComercial/criteriosRemuneracao/UPDATEFIELD', field);
};

export const updateRemuneracao = (value: Remuneracao) => {
  return typedAction('notaComercial/criteriosRemuneracao/remuneracao/UPDATE', value);
};

export const updateRemuneracaoField = (field: RemuneracaoField) => {
  return typedAction('notaComercial/criteriosRemuneracao/remuneracao/UPDATEFIELD', field);
};

export const resetCriteriosRemuneracao = () => {
  return typedAction('notaComercial/criteriosRemuneracao/RESET');
};

export const updateCriteriosRemuneracao = (state: CriteriosRemuneracao) => {
  return typedAction('notaComercial/criteriosRemuneracao/UPDATE', state);
};

export const updateCustoEmissaoField = (field: CustoEmissaoField) => {
  return typedAction('notaComercial/criteriosRemuneracao/custoEmissao/UPDATEFIELD', field);
};

export type CriteriosRemuneracaoAction = ReturnType<
  | typeof updateField
  | typeof updateRemuneracaoField
  | typeof updateRemuneracao
  | typeof resetCriteriosRemuneracao
  | typeof updateCriteriosRemuneracao
  | typeof updateCustoEmissaoField
>;
